import React from 'react';
import AnimeCard from './AnimeCard';

function AnimeGrid({ items, onSelect }) {
  return (
    <div className="results-grid">
      {items.map((item) => (
        <AnimeCard
          key={item.imdbID}
          item={item}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}

export default AnimeGrid;